'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsEligibleForOverrides = getIsEligibleForOverrides;
exports.fetchEnglishOverrides = fetchEnglishOverrides;
exports.initializeCopyMachine = initializeCopyMachine;

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _params = require('hub-http/helpers/params');

var _I18nApi = require('./I18nApi');

var _copyMachineUtils = require('pricing-pages-unified-ui/utils/copyMachineUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENDPOINT = 'copymachine/v1/overrides';
var TEST_ENDPOINT = 'copymachine/v1/specific-overrides';
var TEST_VARIANT = (0, _params.parse)(window.location.search).copy_machine_variant || null;

function reportError(err) {
  _Raven2.default.captureMessage('copym error fetching & applying overrides', {
    extra: {
      message: err.message
    }
  });
  return false;
}

function getIsEligibleForOverrides() {
  return (0, _I18nApi.getLanguage)().then(function (lang) {
    return typeof lang === 'string' && lang.indexOf('en') !== -1;
  });
}

function fetchEnglishOverrides(page, identifier) {
  var variant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (variant) {
    return _noAuthApiClient2.default.get(TEST_ENDPOINT + '/' + page + '/' + variant).then(_copyMachineUtils.adaptForI18n);
  }
  return _noAuthApiClient2.default.get(ENDPOINT + '/' + page + '/' + identifier, { timeout: 4000 }).then(_copyMachineUtils.adaptForI18n);
}

function initializeCopyMachine(page, identifier) {
  return getIsEligibleForOverrides().then(function (isEligible) {
    if (!isEligible || !identifier) {
      return false;
    }

    return fetchEnglishOverrides(page, identifier, TEST_VARIANT).then(function (overrides) {
      try {
        var translationsWithOverrides = (0, _copyMachineUtils.applyOverrides)((0, _I18nApi.getTranslations)('en'), overrides);
        (0, _I18nApi.replaceTranslations)('en', translationsWithOverrides);
      } catch (err) {
        throw err;
      }
      return true;
    }).catch(reportError);
  }).catch(reportError);
}


//////////////////
// WEBPACK FOOTER
// ./js/api/CopyMachineApi.js
// module id = 601
// module chunks = 3 4 5